var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "transparent",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.5 13.76a.494.494 0 0 1-.5-.48V.48c0-.262.227-.48.5-.48s.5.218.5.48v12.8c0 .262-.227.48-.5.48"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M4.672 1.62h6.071a1.5 1.5 0 0 1 1.5 1.5v3.04a1.5 1.5 0 0 1-1.5 1.5H4.672zM1.597 13.016a1.5 1.5 0 0 1 1.412-.996h9.982a1.5 1.5 0 0 1 1.412.995l.172.48a1.5 1.5 0 0 1-1.413 2.005H2.838a1.5 1.5 0 0 1-1.413-2.005z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.428 12.16c-.182.485-.71 1.454-1.366 1.454-.82 0-4.1 0-4.373.582l-.546 1.164"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOper);
export default __webpack_public_path__ + "static/media/oper.4e4b25918b9aedc2e1908c6a7f71648b.svg";
export { ForwardRef as ReactComponent };